<template>
  <OmtStickedModal data-cy="feedback-modal" @close="$emit('close')">
    <OmtIcons v-bind="modalIconBind" size="2x"
mb="32px" />
    <OmtTypography as="h1-bold" mb="32px">
      {{ title }}
    </OmtTypography>

    <CFlex v-if="!!protocol" align="center"
mb="24px">
      <OmtIcons name="square-poll-horizontal" mr="12px" />
      <OmtTypography as="h2-bold"> Protocolo: {{ protocol }} </OmtTypography>
    </CFlex>

    <CBox
      v-if="!!cardTitle"
      bg="var(--colors-light-primary-light-gray)"
      p="10px 16px 16px 16px"
      :mb="['64px', '118px']"
    >
      <CFlex mb="14px">
        <OmtIcons :name="cardIcon" mr="16px" />
        <OmtTypography as="h2-bold">
          {{ cardTitle }}
        </OmtTypography>
      </CFlex>
      <template v-if="htmlCardDescription">
        <OmtTypography as="p1" v-html="cardDescription" />
      </template>
      <template v-else>
        <OmtTypography as="p1">
          {{ cardDescription }}
        </OmtTypography>
      </template>
    </CBox>
    <CBox v-else p="10px 16px 16px 16px"
:mb="['64px', '118px']">
      <OmtTypography v-for="(description, index) in cardDescriptions" :key="`dsc-${index}`"
as="p1">
        {{ description }}
      </OmtTypography>
    </CBox>

    <OmtButton w="100%" @click="$emit('buttonClick')">
      {{ buttonLabel }}
    </OmtButton>
    <OmtButton v-if="secondButtonLabel" w="100%" variant="ghost" @click="$emit('secondButtonClick')">
      {{ secondButtonLabel }}
    </OmtButton>
  </OmtStickedModal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    protocol: {
      type: String
    },
    modalIconBind: {
      type: Object,
      default: () => ({
        name: "paper-plane-top"
      })
    },
    cardTitle: {
      type: String
    },
    cardDescription: {
      type: String
    },
    cardIcon: {
      type: String,
      default: "bell-on"
    },
    buttonLabel: {
      type: String,
      default: "Concluir"
    },
    secondButtonLabel: {
      type: String,
      default: ""
    }
  },
  computed: {
    htmlCardDescription() {
      if (!this.cardDescription) return false;
      return this.cardDescription.includes("<");
    },
    cardDescriptions() {
      return this.cardDescription?.split("|") || "";
    }
  }
};
</script>
